import { render, staticRenderFns } from "./platformPay.vue?vue&type=template&id=3cf88f70&scoped=true&"
import script from "./platformPay.vue?vue&type=script&lang=js&"
export * from "./platformPay.vue?vue&type=script&lang=js&"
import style0 from "./platformPay.vue?vue&type=style&index=0&id=3cf88f70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf88f70",
  null
  
)

export default component.exports